import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, User, Search, Heart } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useNativeFeatures } from '@/hooks/useNativeFeatures';
import { useCart } from '@/contexts/CartContext';

const navItems = [
  { icon: Home, label: 'Home', path: '/' },
  { icon: Search, label: 'Shop', path: '/shop' },
  { icon: ShoppingBag, label: 'Cart', path: '/cart' },
  { icon: Heart, label: 'Wishlist', path: '/dashboard' },
  { icon: User, label: 'Profile', path: '/dashboard' }
];

export const MobileNavigation: React.FC = () => {
  const location = useLocation();
  const { triggerHaptic } = useNativeFeatures();
  const { getCartCount } = useCart();
  const cartItemCount = getCartCount();

  const handleNavClick = async () => {
    await triggerHaptic('light');
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur-md border-t border-border z-50 pb-safe">
      <div className="flex items-center justify-around px-2 py-2">
        {navItems.map(({ icon: Icon, label, path }) => {
          const isActive = location.pathname === path;
          const isCart = label === 'Cart';
          
          return (
            <Link
              key={path}
              to={path}
              onClick={handleNavClick}
              className={cn(
                'flex flex-col items-center justify-center p-2 rounded-lg transition-all duration-200 relative',
                'min-w-[60px] min-h-[60px]',
                isActive 
                  ? 'text-primary bg-primary/10' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
              )}
            >
              <div className="relative">
                <Icon className="h-5 w-5 mb-1" />
                {isCart && cartItemCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs rounded-full h-4 w-4 flex items-center justify-center">
                    {cartItemCount}
                  </span>
                )}
              </div>
              <span className="text-xs font-medium">{label}</span>
              
              {isActive && (
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-primary rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};